module.exports = __webpack_public_path__ + "static/img/blog_onboarding.01cff9d7.svg";